import { useMemo } from "react";
import { DAY_LABELS, MONTH_LABELS, parseDate, toDateStr } from "../../utils";
import SlotCard from "./SlotCard";

export default function TimelineView({
  slots = [],
  onCardClick,
  onRegisterClick,
  onCardDelete,
}) {
  const grouped = useMemo(() => {
    const map = {};
    slots.forEach((slot) => {
      if (!map[slot.slot_date]) map[slot.slot_date] = [];
      map[slot.slot_date].push(slot);
    });
    return Object.entries(map).sort((a, b) => a[0].localeCompare(b[0]));
  }, [slots]);

  const todayStr = toDateStr(new Date());

  return (
    <div className="timeline">
      {grouped.length > 0 ? (
        grouped.map(([date, daySlots]) => {
          const d = parseDate(date);
          const isToday = todayStr === date;
          const dayIndex = d.getDay() === 0 ? 6 : d.getDay() - 1;

          return (
            <div key={date} className="timeline-day">
              <div className={`timeline-date ${isToday ? "today" : ""}`}>
                <div className="timeline-date-label">
                  {DAY_LABELS[dayIndex]} {d.getDate()}{" "}
                  {MONTH_LABELS[d.getMonth()]}
                </div>
              </div>

              <div className="timeline-day-events">
                {daySlots.map((slot) => (
                  <SlotCard
                    key={slot.id}
                    slot={slot}
                    onCardClick={onCardClick}
                    onRegisterClick={onRegisterClick}
                    onDeleteClick={onCardDelete}
                  />
                ))}
              </div>
            </div>
          );
        })
      ) : (
        <div className="calendar-empty">Aucun événement à venir</div>
      )}
    </div>
  );
}
